import React, { useRef, useEffect } from 'react';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { useForm } from 'react-hook-form';

interface IInputProps {
    func: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    value: string;
    stretch?: boolean;
    placeholder?: string;
    formRef?: React.RefObject<HTMLFormElement>; // Dodata referenca na formu
    isDisabled?: boolean;
    loading?: boolean;
    hasRef?: boolean;

}

export const Input: React.FC<IInputProps> = ({loading = false, func, value, stretch = false, placeholder = '...some text', formRef, isDisabled = false, hasRef = true }) => {
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);

    useEffect(() => {
        if (textareaRef.current && !loading) {
            textareaRef.current.focus();
        }
    }, [value, loading]);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;

            const maxHeight = textareaRef.current.scrollHeight;
            const lineHeight = parseInt(window.getComputedStyle(textareaRef.current).lineHeight);
            const maxHeightInRows = 5 * lineHeight; // Maksimalna visina u pikselima

            // Ograničavamo visinu na maksimalan broj redova
            textareaRef.current.style.height = `${Math.min(maxHeight, maxHeightInRows)}px`;
        }
    }, [value]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            formRef?.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
    };

    return (
        <div className={`input-container ${stretch && 'input-container__stretch'}`}>
            <FlexCenter position="start" gap={0.3}>
                <textarea
                    ref={hasRef ? textareaRef : null}
                    autoComplete="off"
                    value={value}
                    placeholder={placeholder}
                    className="input"
                    onChange={func}
                    onKeyDown={handleKeyDown}
                    rows={1}
                    disabled={isDisabled}
                    style={{ resize: 'none', overflow: 'hidden' }}
                />
            </FlexCenter>
        </div>
    );
};
